import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Input } from '@artosera/ui';
import { ETAPES_AFFAIRE } from '@artosera/shared';
import {
  pipelineApi,
  useReglagesPipeline,
  useActionPipeline,
  type ReglagesPipeline,
} from '../../api/pipeline.js';
import { galerieALaction, galerieAModule } from '../../auth/sujet.js';
import { estApiError } from '../../api/errors.js';
import { useShellContext } from '../shell/context.js';
import { Field } from '../Field.js';
import styles from './Pipeline.module.css';
export function ReglagesPipelinePage() {
  const { galerie } = useShellContext();
  const { t } = useTranslation('regie');
  if (
    !galerieAModule(galerie, 'pipeline-ventes') ||
    !galerieALaction(galerie, 'settings:write') ||
    !galerieALaction(galerie, 'pipeline:write')
  )
    return <p role="alert">{t('pipeline.accesRefuse')}</p>;
  return <Reglages />;
}
function Reglages() {
  const { galerieSlug } = useShellContext();
  const { t } = useTranslation(['regie', 'commun']);
  const reglages = useReglagesPipeline(galerieSlug);
  if (reglages.isLoading) return <p role="status">{t('commun:chargement')}</p>;
  if (!reglages.data) return <p role="alert">{t('commun:erreurReseau')}</p>;
  return <Formulaire initial={reglages.data} />;
}
function Formulaire({ initial }: { initial: ReglagesPipeline }) {
  const { galerieSlug } = useShellContext();
  const { t } = useTranslation(['regie', 'commun']);
  const [probabilites, setProbabilites] = useState(initial.probabilites);
  const mutation = useActionPipeline(galerieSlug, (corps: ReglagesPipeline, appel) =>
    pipelineApi.regler(galerieSlug, corps, appel),
  );
  return (
    <section className={styles.page}>
      <h1>{t('regie:pipeline.reglages')}</h1>
      <p>{t('regie:pipeline.descriptionReglages')}</p>
      <form
        className={styles.formulaire}
        onSubmit={(e) => {
          e.preventDefault();
          mutation.mutate({ probabilites, version: initial.version });
        }}
      >
        {ETAPES_AFFAIRE.map((etape) => (
          <Field
            key={etape}
            htmlFor={`probabilite-${etape}`}
            label={t(`regie:pipeline.etapes.${etape}`)}
          >
            <Input
              id={`probabilite-${etape}`}
              type="number"
              required
              min={0}
              max={100}
              step={1}
              value={probabilites[etape]}
              onChange={(e) =>
                setProbabilites({ ...probabilites, [etape]: Number(e.target.value) })
              }
            />
          </Field>
        ))}
        <Button type="submit" loading={mutation.isPending}>
          {t('commun:actions.enregistrer')}
        </Button>
        {mutation.isError ? (
          <p role="alert">
            {estApiError(mutation.error) && mutation.error.status === 409
              ? t('regie:pipeline.conflit')
              : t('commun:erreurReseau')}
          </p>
        ) : null}
      </form>
    </section>
  );
}
